import React from 'react';
import TextField, { StandardTextFieldProps } from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

interface IProps extends StandardTextFieldProps {
  currency?: string;
}

export default function InputPrice(props: IProps) {
  const {
    currency,
    fullWidth,
    required,
    label,
    placeholder,
    onChange,
    value,
  } = props;
  return (
    <TextField
      type="number"
      required={required}
      fullWidth={fullWidth}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{currency}</InputAdornment>
        ),
      }}
    />
  );
}
